import { render, staticRenderFns } from "./MyInsurance.vue?vue&type=template&id=0b79dc06&scoped=true&"
import script from "./MyInsurance.vue?vue&type=script&lang=js&"
export * from "./MyInsurance.vue?vue&type=script&lang=js&"
import style0 from "./MyInsurance.vue?vue&type=style&index=0&id=0b79dc06&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b79dc06",
  null
  
)

export default component.exports